import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import classNames from 'classnames'
import { Image } from 'Components/view-image'
import noopWrapper, { Wrapper } from 'lib/noop-wrapper'
import dynamic from 'next/dynamic'
import Loading from 'Components/loading'
const Player = dynamic(() => import('Components/player'), {
  ssr: false,
  loading: () => <Loading />,
})

export interface IProps {
  groupId?: string
  coverUrl?: string // 封面
  coverAlt?: string // 封面
  videoId?: string // id
  duration?: number // 时长
  type?: number
  linkWrapper?: Wrapper
}

let prevSetState: Dispatch<SetStateAction<boolean>>

const Video: React.FC<IProps> = ({
  coverUrl,
  coverAlt,
  videoId,
  groupId,
  duration,
  type = 1,
  linkWrapper = noopWrapper,
}) => {
  const [showPlayer, setShowPlayer] = useState(false)

  useEffect(() => {
    if (showPlayer) {
      if (prevSetState) prevSetState(false)
      prevSetState = setShowPlayer
    }
  }, [showPlayer])

  return videoId && coverUrl ? (
    showPlayer ? (
      <div className="tw-mt-12 tw-h-378">
        <Player
          className={`tw-h-full`}
          group_id={groupId}
          vid={videoId}
          height={'100%'}
          width={'100%'}
          autoplay={true}
          cover={coverUrl}
          setPIP={false}
        />
      </div>
    ) : (
      <div
        className={classNames('tw-mt-12', type === 1 ? 'tw-w-266' : 'tw-w-150')}
      >
        <div
          className="tw-relative"
          style={{ paddingBottom: type === 1 ? '56.39%' : '175%' }}
        >
          <div
            className="tw-absolute tw-inset-0 tw-cursor-pointer"
            onClick={() => setShowPlayer(true)}
          >
            <React.Fragment>
              <Image
                width={type === 1 ? 266 : 150}
                height={type === 1 ? 150 : 266}
                src={coverUrl || ''}
                alt={coverAlt}
                layout={'fill'}
                autoPixelRatio
              />
              <span className="tw-absolute tw-inset-0 tw-m-auto tw-w-40 tw-h-40 tw-text-white tw-flex tw-items-center tw-justify-center tw-bg-common-black tw-bg-opacity-50 tw-rounded-100">
                <i className="DCD_Icon icon_play_1 tw-text-14 tw-text-24" />
              </span>
            </React.Fragment>
          </div>
        </div>
      </div>
    )
  ) : null
}

export default Video
